export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><g><circle cx=\"10\" cy=\"10\" r=\"10\" /></g></svg>\n";